import { shallowEqual } from 'react-redux';

import { Box, Button, Icon, TextButton } from '@zillow/constellation-10';
import { IconHandshakeFilled } from '@zillow/constellation-icons';

import ConnectedModuleCard from '../../../ConnectedModuleCard';

import ManageTenantsCSEvents from '../../../../model/ClickstreamEvent/ManageTenantsCSEvents';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../../styles';
import { useSelector } from '../../../../selectors/useSelector';

type Props = {
  title: string;
  description: string;
  primaryCtaText: string;
  primaryCtaUrl: string;
  secondaryCtaText?: string;
  secondaryCtaUrl?: string;
};

const EmptyLeasesCard = ({
  title,
  description,
  primaryCtaText,
  primaryCtaUrl,
  secondaryCtaText = '',
  secondaryCtaUrl = '',
}: Props) => {
  const { user } = useSelector((state) => {
    return {
      user: state.user,
    };
  }, shallowEqual);

  const hasSecondaryCTA = !!(secondaryCtaText && secondaryCtaUrl);

  const handleEmptyLeasesCardPrimaryCTAClick = () => {
    ManageTenantsCSEvents.GetStarted({ user });
  };

  const getSecondaryCTAShowHide = () => {
    return (
      <>
        <Button
          asChild
          data-testid="EmptyLeasesCard-DefaultButton"
          tone="brand"
          emphasis="outlined"
          css={{ marginLeft: '200', display: { base: 'none', lg: 'inline-block' } }}
        >
          <a href={secondaryCtaUrl}>{secondaryCtaText}</a>
        </Button>

        <TextButton
          css={{ paddingTop: '200', display: { base: 'inline-block', lg: 'none' } }}
          asChild
          data-testid="EmptyLeasesCard-DefaultAnchor"
        >
          <a href={secondaryCtaUrl}>{secondaryCtaText}</a>
        </TextButton>
      </>
    );
  };

  return (
    <ConnectedModuleCard data-testid="EmptyLeasesCard">
      <StyledEmptyStateContainer>
        <StyledIconContainer>
          <Icon size="xl" css={{ color: 'icon.accent.blue.hero' }} render={<IconHandshakeFilled />} />
        </StyledIconContainer>

        {/* The title can be long.  Using responsive text styling to handle this */}
        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>

        <EmptyStateBodyText asChild>
          <p>{description}</p>
        </EmptyStateBodyText>

        <Box css={{ marginBottom: '600' }} />

        <Box
          css={{
            display: 'flex',
            flexDirection: { base: 'column', lg: 'row' },
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            asChild
            tone="brand"
            emphasis="filled"
            onClick={handleEmptyLeasesCardPrimaryCTAClick}
            data-eventid={ManageTenantsCSEvents.GetStarted.data_event_id}
          >
            <a href={primaryCtaUrl}>{primaryCtaText}</a>
          </Button>

          {hasSecondaryCTA && getSecondaryCTAShowHide()}
        </Box>
      </StyledEmptyStateContainer>
    </ConnectedModuleCard>
  );
};

export default EmptyLeasesCard;
